import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import BackToTop from "./BackToTop";

export default function SiteLayout() {
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    setReady(true);
  }, [location.pathname, location.search]);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className={`flex-1 w-full ${ready ? "animate-fade-in" : ""}`}>
        <Outlet />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}